import React, { useEffect, useMemo, useRef, useState } from "react";
import { connect } from "react-redux";
import {
  ArrowIcon,
  BackArrowIcon,
  FilterIcon,
  TickIcon
} from "../../Assets/assets";
import SearchFallBackIcon from "../../Assets/SearchFallBackIcon.svg";
import Button from "../../Components/Button/Button";
import {
  NoResultsFallback,
  ZeroStateFallback
} from "../../Components/FallBacks/FallBacks";
import Header from "../../Components/Header/Header";
import InputBox from "../../Components/InputBox/InputBox";
import SearchBox from "../../Components/SearchBox/SearchBox";
import {
  setFilter,
  setSearchKey,
  setSortBy
} from "../../Redux/complaints/action";
import { isValidArray, isValidObject } from "../../Services/validators";
import {
  categoryMapping,
  convertTimestampToTimer,
  getRemainingTime,
  getSourceTableValue,
  sourceMapping
} from "../../Utils/Complaints";
import { dateAndTimeConverter } from "../../Utils/constants";
import "./Complaints.css";

function Complaints(props) {
  const [showFilter, setShowFilter] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState({
    category: [],
    dateRange: {
      from: null,
      to: null
    },
    issueRaised: "",
    PCTNo: [],
    source: []
  });

  useEffect(() => {
    setSelectedFilter(props.complaints.filter);
  }, [props.complaints.filter]);

  const getPctNumberData = (data) => {
    if (data && isValidObject(data)) {
      return Object.values(data)?.filter((data) => data.access === "public");
    } else {
      return [];
    }
  };

  const filterData = {
    category: {
      title: "Category",
      value: Object.keys(categoryMapping).map((key) => ({
        label: key,
        value: key
      }))
    },
    issueRaised: {
      title: "Issue Raised"
    },
    dateRange: {
      title: "Date Range",
      value: {
        from: null,
        to: null
      }
    },
    ...(isValidArray(getPctNumberData(props.locations.data))
      ? {
          PCTNo: {
            title: "PCT No",
            value: getPctNumberData(props.locations.data).map((loc) => ({
              label: `${loc.PCTNo} - ${loc.location}`,
              value: loc.PCTNo
            }))
          }
        }
      : {}),
    source: {
      title: "Source",
      value: Object.entries(sourceMapping).map(([label, value]) => ({
        label,
        value
      }))
    }
  };

  function resetFilter() {
    const data = {
      category: [],
      dateRange: {
        from: null,
        to: null
      },
      issueRaised: "",
      PCTNo: [],
      source: []
    };
    setSelectedFilter(data);
    props.setFilter(data);
  }

  const isFilterApplied = useMemo(() => {
    const filterData = props.complaints.filter;
    return (
      filterData?.category?.length > 0 ||
      filterData?.dateRange?.from !== null ||
      filterData?.dateRange?.to !== null ||
      filterData?.issueRaised?.length > 0 ||
      filterData?.PCTNo?.length > 0 ||
      filterData?.source?.length > 0
    );
  }, [props.complaints.filter]);

  return (
    <div className="inherit-parent-height inherit-parent-width overflow-hidden">
      <Header
        title={showFilter ? "Filter" : "Complaints"}
        profileOnClick={() => {
          props.navigate("/settings");
        }}
        theme={props.auth.theme.primaryColor === "#0E0E0E" ? "dark" : "light"}
        backOnClick={
          showFilter
            ? () => {
                resetFilter();
                setShowFilter(false);
              }
            : () => {
                props.navigate("/");
              }
        }
      />
      {!showFilter ? (
        <>
          <SearchBox
            searchKey={props.complaints?.searchKey?.toUpperCase()}
            setSearchKey={props.setSearchKey}
            data-cy={
              props.complaints?.searchKey?.length > 0
                ? "search-clear-button"
                : "search-button"
            }
            placeholder="Search by complaintId"
          />

          <div className="display-flex flex-align-items-center flex-justify-content-space-between padding-left-large padding-right-large padding-bottom-large">
            <div
              style={{
                border: "solid 1px var(--tertiaryColor6)",
                backgroundColor: "#FFFFFF14"
              }}
              className="display-flex flex-align-items-center padding-default"
              data-cy={
                props.complaints.sortBy === "desc"
                  ? "filter-oldest"
                  : "filter-newest"
              }
              onClick={() => {
                if (props.complaints.sortBy === "desc") {
                  props.setSortBy("asc");
                } else {
                  props.setSortBy("desc");
                }
              }}
            >
              <div className="padding-right-default font-size-small font-color-tertiaryColor6">
                {props.complaints.sortBy === "desc" ? "Oldest" : "Newest"}
              </div>
              <div
                className={` display-flex flex-align-items-center  ${
                  props.complaints.sortBy === "desc"
                    ? "rotate-90"
                    : "rotate-270"
                } `}
              >
                <BackArrowIcon color="var(--tertiaryColor6)" />
              </div>
            </div>

            <div
              className="display-flex flex-align-items-center position-relative "
              data-cy="complaints-filter-button"
              onClick={() => {
                setShowFilter(true);
              }}
            >
              <div className="display-flex flex-align-items-center font-size-small padding-right-medium font-color-tertiaryColor6">
                Filter
              </div>
              <FilterIcon color="var(--tertiaryColor6)" />
              {isFilterApplied && (
                <div
                  style={{
                    height: "8px",
                    width: "8px",
                    top: "2px",
                    right: "0px"
                  }}
                  className="background-color-secondary border-radius-16px position-absolute"
                />
              )}
            </div>
          </div>

          {isFilterApplied &&
            isValidObject(props.complaints.data) &&
            Object.values(props.complaints.data)?.length === 0 && (
              <div className="inherit-parent-width remaining-body-height_-229px flex-justify-content-center flex-align-items-center flex-direction-column ">
                <img src={SearchFallBackIcon} alt="no filter result found" />
                <div className="padding-top-larger">NO MATCHING RESULTS</div>
                <div className="padding-top-large">
                  There wasn’t any result matching to the search and filter
                </div>
              </div>
            )}

          <div
            style={{
              height: "calc(100% - 180px)"
            }}
            className="inherit-parent-width flex-direction-column flex-justify-content-center"
          >
            <div className="inherit-parent-height inherit-parent-width max-width-767px overflow-x-scroll hide-scrollbar flex-justify-content-center">
              {!props.complaints.loading &&
                !props.locations.loading &&
                isValidObject(props.complaints.data) &&
                isValidObject(props.locations.data) && (
                  <div className="inherit-parent-width inherit-parent-height">
                    <div
                      className="padding-left-large padding-right-large padding-bottom-large inherit-parent-width inherit-parent-height"
                      data-cy="COMPLAINTS-LIST"
                    >
                      {Object.values(props.complaints.data).map(
                        (data, index) => (
                          <div className="inherit-parent-width" key={index}>
                            <Card
                              onClick={() => {
                                props.navigate(
                                  `/complaints/${data.documentId}`
                                );
                              }}
                              index={index}
                              data={data}
                              locations={props.locations?.data}
                              loading={props.locations?.loading}
                            />
                          </div>
                        )
                      )}
                      {!props.complaints.searchKey &&
                        props.complaints.data &&
                        props.complaints.totalCount >
                          Object.values(props.complaints.data).length && (
                          <div className="display-flex flex-justify-content-center">
                            <div
                              onClick={props.getNextSetOfComplaints}
                              style={{
                                width: "100px",
                                backgroundColor: "rgba(0, 68, 204, 0.16)"
                              }}
                              className="display-flex flex-justify-content-center flex-align-items-center padding-default border-radius-default"
                            >
                              <div className="padding-right-default font-size-small">
                                {props.paginationLoading
                                  ? "Loading"
                                  : "View more"}
                                {""}
                              </div>
                              {props.paginationLoading ? (
                                <div
                                  style={{
                                    width: "16px",
                                    height: "16px"
                                  }}
                                >
                                  <div className="primary-loading-animation" />
                                </div>
                              ) : (
                                <div
                                  style={{
                                    width: "16px",
                                    height: "16px",
                                    transform: "rotate(90deg)"
                                  }}
                                >
                                  <ArrowIcon />
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                )}

              {!props.complaints.loading &&
                !isFilterApplied &&
                !isValidObject(props.complaints.data) && (
                  <ZeroStateFallback
                    title="No upcoming complains"
                    description="There are no complains at the selected PCT location."
                    type="COMPLAINT"
                  />
                )}

              {!props.complaints.loading &&
                isFilterApplied &&
                !isValidObject(props.complaints.data) && (
                  <NoResultsFallback
                    type="COMPLAINT"
                    resetOnClick={() => {
                      setSearchKey(null);
                      resetFilter();
                    }}
                  />
                )}

              {props.complaints.loading ||
                (props.locations.loading && <Suspense />)}
            </div>
            <div className="padding-large">
              <Button
                type="button"
                text="CREATE NEW COMPLAINT"
                boxShadow={false}
                loading={props.loading}
                onClick={() => {
                  props.navigate("/complaints/locationSearch");
                }}
                data-cy="CREATE-COMPLAINT-BUTTON"
              />
            </div>
          </div>
        </>
      ) : (
        <div
          className="remaining-body-height"
          data-cy="complaints-filter-screen"
        >
          <div
            style={{ height: "calc(100% - 72px)" }}
            className="inherit-parent-width padding-bottom-large overflow-scroll"
          >
            {Object.keys(filterData).map((data, index) => (
              <React.Fragment key={index}>
                <Accordion
                  filterKey={data}
                  items={props.items}
                  selectedFilter={selectedFilter}
                  setSelectedFilter={setSelectedFilter}
                  // issuerData={issuerData}
                  data={filterData[data]}
                  complaints={
                    isValidObject(props.complaints.data) &&
                    Object.values(props.complaints.data)
                  }
                  theme={props.theme}
                />
              </React.Fragment>
            ))}
          </div>

          <div className="display-flex padding-large">
            <Button
              type="button"
              className="max-width-500px margin-right-default"
              data-cy="apply-filter-button"
              text="Apply"
              onClick={() => {
                props.setFilter(selectedFilter);
                setShowFilter(false);
              }}
              disabled={
                selectedFilter.dateRange.from >
                  new Date().toISOString().split("T")[0] ||
                selectedFilter.dateRange.to < selectedFilter.dateRange.from ||
                selectedFilter.dateRange.to >
                  new Date().toISOString().split("T")[0]
              }
              boxShadow={false}
            />

            <Button
              type="button"
              variant="transparent"
              className="max-width-500px margin-left-default"
              data-cy={`reset-filter-button`}
              text="Reset"
              onClick={() => {
                resetFilter();
                setShowFilter(false);
              }}
              boxShadow={false}
            />
          </div>
        </div>
      )}
    </div>
  );
}

const Card = (props) => {
  const getCardStyle = useMemo(() => {
    const timestamp = getRemainingTime(props.data.turnaround, +new Date());
    const complaintClosed =
      props.data?.status?.currentStatus === "CLOSED" ? true : false;

    const isNegative = timestamp <= 0;
    const threeHours = 1000 * 60 * 60 * 3;

    if (isNegative) {
      return { backgroundColor: "#D0405A" };
    }

    if (!complaintClosed && timestamp < threeHours && timestamp > 0) {
      return { backgroundColor: "#D17541" };
    }

    return { backgroundColor: "var(--tertiaryColor4)" };
    // eslint-disable-next-line
  }, [props.data.turnaround, props.data]);
  return (
    <div
      onClick={props.onClick}
      className="display-flex inherit-parent-width padding-bottom-large padding-top-large"
      data-cy={`complaint-card-${props.data.documentId}`}
    >
      <div className="inherit-parent-width display-flex flex-justify-content-space-between">
        <div
          style={{
            width: "55%"
          }}
        >
          {!props.loading ? (
            <>
              <div className="display-flex flex-align-items-center padding-bottom-default">
                <div className="font-size-small">{props.data.documentId}</div>
              </div>
              <div
                title={props.data.category?.toString()?.toLowerCase()}
                className="font-size-medium text-capitalize padding-bottom-default inherit-parent-width text-overflow-ellipsis font-color-tertiaryColor6"
              >
                {props.data.category?.toString()?.toLowerCase()}
              </div>
              <div className="font-size-smaller font-color-tertiaryColor6">
                {`${props.locations?.[
                  props.data.location.id
                ]?.PCTNo?.toString().padStart(2, "0")}
              - ${props.locations?.[props.data.location.id]?.location}`}
              </div>
            </>
          ) : (
            <div className="inherit-parent-width">
              <div className="shimmer padding-large inherit-parent-width" />
            </div>
          )}
        </div>
        <div
          style={{
            width: "45%"
          }}
          className="display-flex"
        >
          <div
            style={{
              height: "100%",
              width: "2px",
              ...getCardStyle
            }}
          />
          <div className="display-flex flex-direction-column text-align-right padding-left-larger">
            <div className="font-size-small white-space-nowrap font-color-tertiaryColor6 padding-bottom-default">
              {dateAndTimeConverter(props.data.createdAt, "cardDate")} ,{""}
              {dateAndTimeConverter(props.data.createdAt, "Time")}
            </div>
            <div
              style={{
                width: "138px"
              }}
              className="font-size-medium white-space-nowrap padding-bottom-default"
            >
              {getSourceTableValue(props.data.issuedBy.type)}
            </div>
            <div
              style={{
                width: "fit-content",
                alignSelf: "flex-end"
              }}
              className="font-size-small"
            >
              {props.data.turnaround
                ? convertTimestampToTimer(
                    getRemainingTime(props.data.turnaround, +new Date()),
                    props.data?.status?.currentStatus === "CLOSED"
                      ? true
                      : false
                  )
                : "N/A"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = function (state) {
  return {
    auth: state.auth,
    complaints: state.complaints,
    locations: state.locations
  };
};

const mapDispatchToProps = function () {
  return {
    setFilter: (data) => setFilter(data),
    setSearchKey: (data) => setSearchKey(data),
    setSortBy: (data) => setSortBy(data)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Complaints);

const Suspense = () => {
  return (
    <div className="inherit-parent-width padding-top-large">
      {[...Array(7)].map((_data, index) => (
        <div className="inherit-parent-width" key={index}>
          <div className="shimmer padding-larger inherit-parent-width" />
        </div>
      ))}
    </div>
  );
};

const Accordion = (props) => {
  const [show, setShow] = useState(false);

  return (
    <>
      <div
        style={{
          backgroundColor: show
            ? "var(--tertiaryColor1)"
            : "var(--primaryColor)"
        }}
        className={`display-flex flex-justify-content-space-between padding-left-large padding-right-large padding-top-large padding-bottom-large ${
          show ? "" : ""
        } position-sticky top-0`}
        data-cy={`${props.filterKey}`}
        onClick={() => {
          if (show === false) {
            setShow(true);
          } else {
            setShow(false);
          }
        }}
      >
        <div className={`${show ? "" : ""} font-size-medium`}>
          {props.data.title}
        </div>
        <DropDownButton
          dropDownButton-data-cy="title-dropDown"
          dropDownClick={() => {
            if (show === false) {
              setShow(true);
            } else {
              setShow(false);
            }
          }}
          showData={show}
          theme={props.theme}
        />
      </div>

      {show ? (
        <div
          style={{
            backgroundColor: show
              ? "var(--tertiaryColor1)"
              : "var(--primaryColor)"
          }}
        >
          {["category", "source", "PCTNo"].includes(props.filterKey) ? (
            <MultipleSelectOption
              filterKey={props.filterKey}
              selectedFilter={props.selectedFilter}
              setSelectedFilter={props.setSelectedFilter}
              values={props.data.value}
            />
          ) : (
            <></>
          )}

          {props.filterKey === "issueRaised" ? (
            <div className="padding-left-large padding-right-large inherit-parent-width">
              <InputBox
                name="phoneNumber"
                label="PHONE NUMBER"
                type="text"
                autoFocus={true}
                removeResponsive={true}
                autoComplete="off"
                value={props.selectedFilter.issueRaised}
                onChange={(e) => {
                  props.setSelectedFilter({
                    ...props.selectedFilter,
                    issueRaised: e.target.value
                  });
                }}
                data-cy="phoneNumber-issueRaised"
                required
              />
            </div>
          ) : (
            <></>
          )}

          {props.filterKey === "dateRange" ? (
            <CustomDateRange
              data={{ key: "dateRange" }}
              selectedFilters={props.selectedFilter}
              setSelectedFilters={props.setSelectedFilter}
            />
          ) : (
            <></>
          )}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

const DropDownButton = (props) => {
  return (
    <div
      className={`${props.className} cursor-pointer`}
      onClick={props.dropDownClick}
      data-cy={props["dropDownButton-data-cy"]}
    >
      <div
        style={{ rotate: props.showData ? "270deg" : "90deg" }}
        className="flex-justify-content-center"
      >
        <ArrowIcon color="var(--tertiaryColor6)" />
      </div>
    </div>
  );
};

export const EmployeeCard = (props) => {
  return (
    <div
      data-cy={props["data-cy"]}
      onClick={props.cardOnclick}
      className="display-flex cursor-pointer flex-justify-content-center flex-align-items-center inherit-parent-width"
    >
      {props.selected ? (
        <div className="margin-right-large">
          <TickIcon
            color={props.theme === "dark" ? "white" : "#404040"}
            width={16}
            height={16}
          />
        </div>
      ) : (
        <div className="margin-right-large">
          <TickIcon color={"rgba(0, 0, 0, 0)"} width={16} height={16} />
        </div>
      )}
      <div className="display-flex flex-direction-column flex-justify-content-space-between inherit-parent-width">
        <div
          style={{
            width: "calc(100% - 100px)"
          }}
          className="text-uppercase text-overflow-ellipsis font-size-small"
        >
          {props.data?.name || "NOT PROVIDED"} ({props.count()})
        </div>
        <div className="text-capitalize padding-top-small font-size-small">
          {props.data?.phoneNumber || "NOT PROVIDED"}
        </div>
      </div>
    </div>
  );
};

const CustomDateRange = (props) => {
  const [isFocused, setIsFocused] = useState({ from: false, to: false });
  const inputRefs = {
    from: useRef(null),
    to: useRef(null)
  };

  return (
    <div className="padding-left-large padding-right-large padding-bottom-large">
      {["FROM", "TO"].map((label) => {
        const key = label.toLowerCase();

        return (
          <div
            key={label}
            style={{
              borderBottom: `solid 1px ${
                isFocused[key]
                  ? "var(--tertiaryColor)"
                  : "var(--tertiaryColor4)"
              }`
            }}
            className="position-relative"
            onFocus={() => setIsFocused((prev) => ({ ...prev, [key]: true }))}
            onBlur={() => setIsFocused((prev) => ({ ...prev, [key]: false }))}
          >
            <div
              onFocus={() => setIsFocused((prev) => ({ ...prev, [key]: true }))}
              onBlur={() => setIsFocused((prev) => ({ ...prev, [key]: false }))}
              className="padding-top-large font-size-smaller"
            >
              {label}
            </div>
            <div style={{ position: "relative" }}>
              <input
                ref={inputRefs[key]}
                style={{
                  width: "100%",
                  border: "none",
                  backgroundColor: "transparent",
                  paddingBottom: "10px",
                  color: "var(--tertiaryColor6)",
                  colorScheme:
                    getComputedStyle(document.documentElement).getPropertyValue(
                      "--primaryColor"
                    ) === "#0E0E0E"
                      ? "dark"
                      : "light",
                  paddingRight: "28px"
                }}
                type="date"
                data-cy={`FILTER-${label}-FIELD`}
                value={props.selectedFilters?.[props.data.key]?.[key] || ""}
                onFocus={() =>
                  setIsFocused((prev) => ({ ...prev, [key]: true }))
                }
                onBlur={() =>
                  setIsFocused((prev) => ({ ...prev, [key]: false }))
                }
                onChange={(e) => {
                  props.setSelectedFilters({
                    ...props.selectedFilters,
                    [props.data.key]: {
                      ...props.selectedFilters[props.data.key],
                      [key]: e.target.value
                    }
                  });
                }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

const MultipleSelectOption = (props) => {
  const selectedValues = props.selectedFilter[props.filterKey] || [];

  const handleSelect = (itemValue) => {
    const isSelected = selectedValues.includes(itemValue);
    const updated = isSelected
      ? selectedValues.filter((v) => v !== itemValue)
      : [...selectedValues, itemValue];

    props.setSelectedFilter({
      ...props.selectedFilter,
      [props.filterKey]: updated
    });
  };

  return props.values?.map(({ label, value }, index) => (
    <div
      key={index}
      className="padding-bottom-default padding-top-default display-flex flex-align-items-center cursor-pointer"
      data-cy={`${selectedValues.includes(value) ? "selected-" : ""}${
        props.filterKey
      }-${label}`}
      onClick={() => handleSelect(value)}
    >
      <div className="display-flex font-size-default flex-justify-content-center flex-align-items-center margin-left-large">
        <div className="margin-right-large" style={{ width: 16, height: 16 }}>
          {selectedValues.includes(value) && (
            <TickIcon color="var(--secondaryColor)" height={16} width={16} />
          )}
        </div>
        <div className="font-size-medium">{label}</div>
      </div>
    </div>
  ));
};
